
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { FileReferenceModel } from 'models/generated/Entities.GormCrm.FileReference';
import { TaskAttachmentModel } from 'models/generated/Entities.GormCrm.TaskAttachment';
import { SaleAttachmentModel } from 'models/generated/Entities.GormCrm.SaleAttachment';


const _gormCrm_UploadControllerHelper = new Map<string, Object>();
_gormCrm_UploadControllerHelper.set('CreateBlobAndReferences', FileReferenceModel);
_gormCrm_UploadControllerHelper.set('UpdateFileReference', FileReferenceModel);
_gormCrm_UploadControllerHelper.set('CreateTaskAttachmentPermanent', TaskAttachmentModel);
_gormCrm_UploadControllerHelper.set('CreateCompanyAttachment', TaskAttachmentModel);
_gormCrm_UploadControllerHelper.set('CreateSaleAttachmentOrder', SaleAttachmentModel);
_gormCrm_UploadControllerHelper.set('CreateSaleAttachmentCompany', SaleAttachmentModel);
_gormCrm_UploadControllerHelper.set('UploadSaleAttachmentOrderByUser', SaleAttachmentModel);


export const gormCrm_UploadControllerHelper = _gormCrm_UploadControllerHelper;

